/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Andrey Dubov
 * @version 1.23.0
 * @since 1.23.0
 */

import { useMemo } from 'react';

import { ECreateInquiryFieldVisibility } from '../constants';
import { ICreateInquiryAttribute, ICreateInquiryGetAttributes } from '../types';

export const useMasterAttributes = (attributes?: ICreateInquiryGetAttributes) => {
    return useMemo(
        () =>
            (attributes?.customAttrs ?? []).reduce(
                (masterAttributes: { [code: string]: ICreateInquiryAttribute }, attribute: ICreateInquiryAttribute) => {
                    if (
                        attribute.declaration.accessibility !== ECreateInquiryFieldVisibility.hidden &&
                        attribute.declaration.isMaster
                    ) {
                        masterAttributes[attribute.code] = attribute;
                    }

                    return masterAttributes;
                },
                {},
            ),
        [attributes],
    );
};
